import { RunModel } from 'models/RunModel/RunModel';
import { createContext, useContext } from 'react';
import { Area } from 'services/Database/CloudStorageService';
import { IService } from 'services/IService';
import { ST } from '../../types';

export interface PlayDataResponse {
  name: string;
  b64s: string;
}

type KeyStatusText = 'nonexistent' | 'active' | 'expired' | 'cancelled';
export interface KeyStatusResponse {
  title: string;
  text: KeyStatusText;
}
export interface KeyBindResponse {
  title: string;
  text: KeyStatusText | 'success' | 'failed' | 'existing';
}
export interface DongleStatusResponse {
  title: string;
  text: 'nonexistent' | 'demo' | 'bound' | 'existing';
}
export interface APIResponse {
  title: string;
  text: 'failed' | 'success';
}
export interface DongleBindResponse extends APIResponse {}

export type EstimatorInterface = {
  submitRecordData: (
    record: RunModel,
    recordId?: string
  ) => Promise<ST.Play>;
  checkKeyStatus: (key: string) => Promise<KeyStatusResponse>;
  bindKey: (key: string) => Promise<KeyBindResponse>;

  checkDongleStatus: (mac: string) => Promise<DongleStatusResponse>;
  bindDongle: (mac: string) => Promise<DongleBindResponse>;
  deleteUser: () => Promise<APIResponse>;
  deleteRun: (
    deviceId: string,
    recordId: string,
    area?: Area
  ) => Promise<APIResponse>;
} & IService;

const APIServiceContext = createContext<null | EstimatorInterface>(null);

export const APIProvider = APIServiceContext.Provider;
export function useCalculationsAPI() {
  const service = useContext(APIServiceContext);
  if (service === null) {
    throw new Error('APIService cannot be null, please add a context provider');
  }
  return service;
}
